import { combineReducers } from 'redux'
import { reducer as allCenters } from './getAllCenters'
import { reducer as disabledCenters } from './getDisabledCenters'
import { reducer as addCenter } from './addCenter'
import { reducer as editCenter } from './editCenter'

export default combineReducers({
    disabledCenters,
    allCenters,
    addCenter,
    editCenter,
})
